import Franchises from "../CompanyDetail/Franchise/Franchises";
const FranchisesContainer = () => {
    return ( <div className="company__body__items">
    <div className="companydetail__info__label">
        <h6>
            Franchises
        </h6>
    </div>
    <div className="company__component__country">
        <Franchises/>
    </div>
    </div> );
}


 
export default FranchisesContainer;